import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9.266 10.755a2.78 2.78 0 0 0-2.484-1.537 2.782 2.782 0 1 0 0 5.564 2.77 2.77 0 0 0 2.484-1.537M17.218 9.566a2.782 2.782 0 1 0 0-5.565 2.782 2.782 0 0 0-2.49 4.027M14.724 15.972c-.926 1.843.417 4.027 2.49 4.027a2.782 2.782 0 1 0 0-5.564"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.217 9.566a2.78 2.78 0 0 1-2.49-1.538l-5.46 2.734c.187.376.299.793.299 1.245s-.112.87-.3 1.245l5.46 2.734a2.78 2.78 0 0 1 2.491-1.537"
    }, null, -1)
  ]))]))
}
export default { render: render }